import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { resetPassword } from "@/api";

export const useResetPassword = () => {
  return useMutation<unknown, AxiosError<{ detail: string }>, string>(
    async (email) => {
      await resetPassword(email);
    },
  );
};
